<template>
	<div class="content">
		<!-- RESPONSE MODAL -->

		<div v-if="state === 'view_response'" id="response_modal">
			<div id="response_batch">
				<h3 class="response_header">Responses</h3>
				<div
					id="response_container"
					v-if="
						selectedItem &&
							selectedItem.response &&
							selectedItem.response.length > 0
					"
				>
					<span
						v-for="(row, rowKey) in selectedItem.response"
						v-bind:key="'row-' + rowKey"
						style="margin-bottom: 32px; display: block"
					>
						<h4>
							<strong>Response {{ rowKey + 1 }}</strong>
						</h4>
						<p class="recorded_at_time">
							Recorded At
							{{
								new Date(row["created_at"]).toLocaleString(
									"en-US",
								)
							}}
						</p>
						<div class="response_line">
							<p class="response_title">Response Level</p>
							<p class="response_text">{{ row["log_level"] }}</p>
						</div>
						<div class="response_line">
							<p class="response_title">Reference</p>
							<p class="response_text">{{ row["order_ref"] }}</p>
						</div>
						<div class="response_line">
							<p class="response_title">Disco</p>
							<p class="response_text">
								{{ selectedItem.request["disco_code"] }}
							</p>
						</div>
						<div class="response_line">
							<p class="response_title">Time</p>
							<p class="response_text">{{ row["created_at"] }}</p>
						</div>
						<div class="response_line">
							<p class="response_title">Asset Reference</p>
							<p class="response_text">
								{{ selectedItem["request"]["meter_no"] }}
							</p>
						</div>
						<div class="response_line">
							<p class="response_title">Model</p>
							<p class="response_text">
								{{ selectedItem.request["vend_type"] || "N/A" }}
							</p>
						</div>
						<div class="response_line">
							<p class="response_title">Vend Amount</p>
							<p class="response_text">
								₦ {{ selectedItem.request["amount"] }}
							</p>
						</div>
						<div class="response_line">
							<p class="response_title">Status</p>
							<p class="response_text">
								{{ selectedItem.status }}
							</p>
						</div>
						<div class="response_line">
							<p class="response_title">Response Message</p>
							<p class="response_text">
								{{
									row["response_body"]["response_message"] ||
										row["message"]
								}}
							</p>
						</div>
						<div class="response_line">
							<p class="response_title">Response Code</p>
							<p class="response_text">
								{{
									row["response_body"]["response_code"] ||
										row["response_body"]["code"]
								}}
							</p>
						</div>
						<div class="response_line">
							<p class="response_title">Token</p>
							<p class="response_text">
								{{ row["response_body"]["token"] || "N/A" }}
							</p>
						</div>
						<div
							class="response_line"
							v-if="row['response_body']['parcels']"
						>
							<p class="response_title">Parcels</p>

							<div class="response_text">
								<div
									v-for="(token, tokenKey) in row
										.response_body.parcels"
									:key="'token-' + tokenKey"
									class="parcel"
								>
									<p>{{ token.type }}</p>
									<p>{{ token.content }}</p>
								</div>
							</div>
						</div>
						<div class="response_line">
							<p class="response_title">Debt</p>
							<p class="response_text">
								{{ row["debt"] || "N/A" }}
							</p>
						</div>
					</span>
				</div>
				<div class="processing_info" v-else-if="selectedItem.error">
					<p class="response_text" id="empty_response">
						{{ selectedItem.error.message }}
					</p>
				</div>
				<div class="loading_response" v-else>
					<div class="loader"></div>
					<p class="response_text" id="empty_response">
						Loading Responses...
					</p>
				</div>
				<p @click="cancelBatch" class="cancel_response">CLOSE</p>
			</div>
		</div>

		<!-- END RESPONSE MODAL -->
		<div
			style="display: flex;
      flex-flow: column nowrap;
      justify-content: space-between;
      width: 100%;
      align-items: center;"
		>
			<vue-csv-downloader
				class="button"
				id="export-button"
				style="margin-bottom: 8px"
				v-if="status !== 'PROCESSING' && processedItems.length > 0"
				:data="processedItems"
				:download-name="
					`BP_Batch_Order_${batchId}_${activeTab
						.charAt(0)
						.toUpperCase() + activeTab.slice(1)}_${Date.now()}`
				"
				:fields="exportHeaders"
			>
				Export
				{{
					activeTab.charAt(0).toUpperCase() + activeTab.slice(1)
				}}
				Results To CSV
			</vue-csv-downloader>
			<div class="top-button-container" style="margin-bottom: 16px">
				<button
					v-if="status === 'PROCESSING'"
					class="top-button"
					@click="cancelRequest"
				>
					<img :src="PauseIcon" /> Pause
				</button>
				<button
					v-if="
						status === 'PROCESSING_INCOMPLETE' ||
							(processedItems.length < totalItemsCount &&
								status !== 'PROCESSING')
					"
					class="top-button"
					@click="resumeBatch"
				>
					<img :src="ReplayIcon" /> Resume Batch Processing
				</button>
				<!-- <button
          v-if="status === 'PROCESSING_COMPLETE'"
          class="top-button"
        >
          <img :src="ReplayIcon" />
          Run Again
        </button> -->
			</div>
			<div
				style="width: 100%;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;
        margin-left: auto"
			>
				<div id="tab-container">
					<span
						class="tab"
						:style="{
							background: `${activeTab === 'all' ? '#fff' : ''}`,
						}"
						@click="filter('all')"
						>All ({{ processedItemsCount }})</span
					>
					<span
						class="tab"
						:style="{
							background: `${
								activeTab === 'successful' ? '#fff' : ''
							}`,
						}"
						@click="filter('successful')"
						>Successful ({{ successfulCount }})</span
					>
					<span
						class="tab"
						:style="{
							background: `${
								activeTab === 'pending' ? '#fff' : ''
							}`,
						}"
						@click="filter('pending')"
						>Pending ({{ pendingCount }})</span
					>
					<span
						class="tab"
						:style="{
							background: `${
								activeTab === 'failed' ? '#fff' : ''
							}`,
						}"
						@click="filter('failed')"
						>Failed ({{ failedCount }})</span
					>
				</div>
				<div id="processing_info_container">
					<span
						class="processing_info"
						v-if="status === 'PROCESSING'"
					>
						<div class="loader"></div>
						<p class="response_text">
							Processing Item
							<strong>{{
								processedItemsCount + 1 > totalItemsCount
									? totalItemsCount
									: processedItemsCount
							}}</strong>
							of <strong>{{ totalItemsCount }}</strong> Items
						</p>
					</span>
					<p
						v-if="totalItemsCount > 0 && status !== 'PROCESSING'"
						class="response_text m-0"
					>
						Total Batch Payload Size -
						<strong>{{ totalItemsCount }}</strong> Items
					</p>
					<p
						v-if="totalItemsCount > 0 && status !== 'PROCESSING'"
						class="response_text m-0 ml-2"
					>
						Unprocessed Items Count -
						<strong>{{ remainingItemsCount }}</strong> Items
					</p>
				</div>
				<button
					class="button"
					id="resume-button"
					style="margin-bottom: 8px"
					@click="retryPendingItems"
					v-if="hasPendingItems && status !== 'PROCESSING'"
				>
					Retry All Pending
				</button>
			</div>
		</div>

		<div v-if="processedItems.length > 0" id="orders-container">
			<div
				class="order-summary"
				v-for="(row, rowKey) in visibleOrders"
				v-bind:key="'row-' + rowKey"
			>
				<div class="order-status">
					<span
						class="order-status-text"
						:style="{
							background: `${
								visibleOrders[rowKey]['status'] &&
								visibleOrders[rowKey]['status'] === 'SUCCESSFUL'
									? '#D0ECDE'
									: '#F3C1BC'
							}`,
							color: `${
								visibleOrders[rowKey]['status'] &&
								visibleOrders[rowKey]['status'] === 'SUCCESSFUL'
									? '#67AD5B'
									: '#E15241'
							}`,
						}"
						>{{ visibleOrders[rowKey]["status"] || "FAILED" }}</span
					>
				</div>
				<div class="order-details">
					<div class="order-detail-item">
						<span class="text-muted order-detail-title"
							>Order ID</span
						>
						<span class="order-detail-content">
							{{
								visibleOrders[rowKey]["order_ref"] ||
									visibleOrders[rowKey]["orderId"]
							}}
						</span>
					</div>
					<div class="order-detail-item">
						<span class="text-muted order-detail-title"
							>Batch ID</span
						>
						<span class="order-detail-content">
							{{
								visibleOrders[rowKey]["batch_id"] ||
									visibleOrders[rowKey]["batchId"]
							}}
						</span>
					</div>
					<div class="order-detail-item">
						<span class="text-muted order-detail-title"
							>Amount</span
						>
						<span class="order-detail-content">
							{{
								formatAmount(
									visibleOrders[rowKey]["request"]["amount"],
								)
							}}
						</span>
					</div>
					<div class="order-detail-item m-0">
						<span class="text-muted order-detail-title"
							>Meter ID</span
						>
						<span class="order-detail-content">
							{{
								visibleOrders[rowKey]["request"]["meter_no"] ||
									visibleOrders[rowKey]["request"]["meter"]
							}}
						</span>
					</div>
					<div class="order-detail-item m-0">
						<span class="text-muted order-detail-title">Disco</span>
						<span class="order-detail-content">
							{{
								visibleOrders[rowKey]["request"][
									"disco_code"
								] || visibleOrders[rowKey]["request"]["disco"]
							}}
						</span>
					</div>
					<div class="order-detail-item m-0">
						<span class="text-muted order-detail-title"
							>Vertical</span
						>
						<span class="order-detail-content">
							{{ visibleOrders[rowKey]["request"]["vertical"] }}
						</span>
					</div>
				</div>
				<div class="order-actions">
					<span
						@click="
							fetchBatchOrderItem(visibleOrders[rowKey]['id'])
						"
						v-if="visibleOrders[rowKey]['id']"
						>Response</span
					>
					<span
						v-if="
							visibleOrders[rowKey]['status'] === 'PENDING' &&
								status !== 'PROCESSING'
						"
						>|</span
					>
					<span
						v-if="
							visibleOrders[rowKey]['status'] === 'PENDING' &&
								status !== 'PROCESSING'
						"
						@click="retryItem(visibleOrders[rowKey], rowKey)"
						>Retry</span
					>
				</div>
			</div>
		</div>
		<div
			style="display: flex; flex-flow: row nowrap; justify-content: space-between; align-items: center;"
		>
			<div
				style="display: flex; flex-flow: row nowrap; align-items: center"
			>
				<select
					class="top-button"
					v-model="pageSize"
					style="margin: 0;"
				>
					<option :value="5">5</option>
					<option :value="20">20</option>
					<option :value="50">50</option>
				</select>
				<p class="response_text m-0" style="margin-left: 8px;">
					Showing <strong>{{ offsetStart }}</strong> to
					<strong>{{ offsetEnd }}</strong> of
					<strong>{{ this.processedItems.length }}</strong> Items
				</p>
			</div>
			<div style="display: flex; flex-flow: row nowrap;">
				<button
					v-if="page > 1"
					class="top-button"
					@click="prevPage"
					style="margin: 0;"
				>
					Previous Page
				</button>
				<button
					v-if="
						offsetEnd < processedItems.length &&
							status !== 'PROCESSING'
					"
					class="top-button"
					@click="nextPage"
				>
					Next Page
				</button>
			</div>
		</div>
		<md-snackbar
			md-position="center"
			:md-duration="6000"
			:md-active.sync="snackBar.show"
			md-persistent
		>
			<span>{{ snackBar.message }}</span>
		</md-snackbar>
	</div>
</template>
<script>
import VueCsvDownloader from "vue-csv-downloader";
import http from "../../utils/Http.util";
import PauseIcon from "../../assets/img/pause.png";
import StopIcon from "../../assets/img/stop.png";
import ReplayIcon from "../../assets/img/replay.png";
import { formatAmount } from "../../utils/Formatter.util";

export default {
	data() {
		return {
			processedItems: [],
			unprocessedItems: [],
			failedItems: [],
			pendingItems: [],
			successfulItems: [],
			processedItemsCount: 0,
			pendingCount: 0,
			successfulCount: 0,
			failedCount: 0,
			page: 1,
			pageSize: 5,
			batchId: 0,
			status: "INDEX",
			remainingItemsCount: 0,
			totalItemsCount: 0,
			currentProcess: "",
			itemExpanded: false,
			selectedItem: {},
			activeTab: "all",
			state: "",
			shouldProcessNext: true,
			PauseIcon,
			StopIcon,
			ReplayIcon,
			exportName: `BP_Batch_Order_${this.batchId}_${new Date()}`,
			exportHeaders: [
				{ label: "Order ID", value: "order_ref" },
				{ label: "Batch ID", value: "batch_id" },
				{ label: "Status", value: "status" },
				{ label: "Business ID", value: "business_id" },
				{ label: "Completion Time", value: "completed_at" },
				{ label: "Phone", value: "request.phone" },
				{ label: "Disco ID", value: "request.disco_code" },
				{ label: "Meter No", value: "request.meter_no" },
				{ label: "Vend Type", value: "request.vend_type" },
				{ label: "Vertical", value: "request.vertical" },
				{
					label: "Token",
					value: (row) => {
						if (row.response) {
							const ownResponse = row.response.filter(
								(res) => +res.item_id === row.id,
							);
							if (ownResponse.length > 0) {
								return (
									ownResponse[ownResponse.length - 1]
										.response_body.token || "N/A"
								);
							}
						}
						return "N/A";
					},
				},
				{
					label: "Description",
					value: (row) => {
						if (row.response) {
							const ownResponse = row.response.filter(
								(res) => +res.item_id === row.id,
							);
							if (ownResponse.length > 0) {
								return (
									ownResponse[ownResponse.length - 1]
										.response_body.response_message ||
									ownResponse[ownResponse.length - 1].message
								);
							}
						}
						return "Response Unavailable. Please Contact Support!";
					},
				},
			],
			snackBar: {
				show: false,
				message: null,
			},
		};
	},
	computed: {
		hasPendingItems() {
			return this.processedItems.some(
				(item) => item.status === "PENDING",
			);
		},
		visibleOrders() {
			if (status === "PROCESSING") {
				return this.processedItems.slice(-this.pageSize);
			}
			const start = (this.page - 1) * this.pageSize;
			const end = start + this.pageSize;
			return this.processedItems.slice(start, end);
		},
		offsetStart() {
			if (this.status === "PROCESSING")
				return Math.max(
					this.processedItems.length - this.pageSize + 1,
					1,
				);
			return (this.page - 1) * this.pageSize + 1;
		},
		offsetEnd() {
			if (this.status === "PROCESSING") return this.processedItems.length;
			return Math.min(
				(this.page - 1) * this.pageSize + this.pageSize,
				this.processedItems.length,
			);
		},
	},
	components: {
		VueCsvDownloader,
	},
	methods: {
		prevPage() {
			if (this.page <= 1) return;
			return this.page--;
		},
		nextPage() {
			if (this.offsetEnd >= this.processedItems.length) return;
			return this.page++;
		},
		formatAmount,
		filterInPlace(arr, predicate) {
			let write = 0;

			for (let read = 0; read < arr.length; read++) {
				if (predicate(arr[read])) {
					arr[write++] = arr[read];
				}
			}

			arr.length = write;
		},
		async filter(pred) {
			this.page = 1;
			// refetch batch order so we use server state as source of truth for processed items, and we begin processing from there
			this.$store.commit("busyStatus", true);
			await this.fetchBatchOrder(this.batchId);
			this.$store.commit("busyStatus", false);
			switch (pred) {
				case "all":
					this.activeTab = "all";
					break;
				case "successful":
					this.activeTab = "successful";
					this.processedItems = this.successfulItems;
					break;
				case "pending":
					this.activeTab = "pending";
					this.processedItems = this.pendingItems;
					break;
				case "failed":
					this.activeTab = "failed";
					this.processedItems = this.failedItems;
					break;
				default:
					return this.processedItems;
			}
		},
		async cancelRequest() {
			// refetch batch order so we use server state as source of truth for processed items, and we stop processing
			this.$store.commit("busyStatus", true);
			await this.fetchBatchOrder(this.batchId);
			this.$store.commit("busyStatus", false);
			this.shouldProcessNext = false;
			this.status =
				this.unprocessedItems.length > 0
					? "PROCESSING_INCOMPLETE"
					: "PROCESSING_COMPLETE";
		},
		extractOrderIds() {
			// Use the map method to create an array of order_ids
			return this.processedItems
				.map((order) => order.order_ref) // Extract order_id from each order
				.filter((id) => id != null); // Filter out any undefined values
		},
		sieveItems(batchOrder) {
			const processedIds = new Set(this.extractOrderIds());

			return batchOrder.payload.filter(
				(item) => !processedIds.has(item.orderId),
			);
		},
		cancelBatch() {
			this.state = "";
			this.selectedItem = {};
		},
		async processItem(item) {
			this.status = "PROCESSING";
			if (!this.shouldProcessNext) {
				this.snackBar = {
					show: true,
					message: "Processing has been cancelled.",
				};
				return;
			}
			this.currentProcess = item.orderId;
			if (!this.batchId) {
				this.snackBar = {
					show: true,
					message: "There is no batch id. Please retry",
				};
				return;
			}
			item.batchId = this.batchId;
			return new Promise((resolve, reject) => {
				http.authReq("/dashboard/batch-orders/items", item, "post")
					.then((res) => {
						resolve(res);
					})
					.catch((err) => {
						if (http.isCancel(err)) {
							this.status = "PROCESSING_INCOMPLETE";
						}
						reject(err);
					})
					.finally(() => {
						this.snackBar = {
							show: true,
							message: "Order Processing Complete.",
						};
						this.currentProcess = "";
					});
			});
		},
		buildOrderObjectFromItemModel(item) {
			return {
				batchId: item.batch_id,
				orderId: item.order_ref,
				amount: item.request.amount,
				disco: item.request.disco_code,
				meter: item.request.meter_no,
				paymentType: item.request.payment_type,
				phone: item.request.phone,
				vendType: item.request.vend_type,
				vertical: item.request.vertical,
			};
		},
		async resumeBatch() {
			this.shouldProcessNext = true;
			if (this.unprocessedItems.length < 1) {
				this.snackBar = {
					show: true,
					message: "Batch Processed Fully, No Items To Process!",
				};
				return;
			}
			this.snackBar = {
				show: true,
				message: "Resuming Batch::: Beginning Processing!",
			};

			// refetch batch order so we use server state as source of truth for processed items, and we begin processing from there
			this.$store.commit("busyStatus", true);
			await this.fetchBatchOrder(this.batchId);
			this.$store.commit("busyStatus", false);

			// reset the page and filter
			this.page = 1;
			this.activeTab = "all";

			const preppedArray = this.unprocessedItems.map((item) => ({
				...item,
				batchId: this.batchId,
			}));

			await this.cycleRequests(preppedArray, 0, true);
		},
		async cycleRequests(arr, i, isNewBatch) {
			if (!arr[i]) {
				this.status = "PROCESSING_COMPLETE";
				this.$router.go(0);
				return;
			}

			try {
				const res = await this.processItem(
					arr[i].batchId // if item contains batchId field then do not run through adapter
						? arr[i]
						: this.buildOrderObjectFromItemModel(arr[i]),
				);

				if (res.responseCode === 202) {
					this.processedItems = Object.freeze([
						...this.processedItems,
						{
							...arr[i],
							status: "PENDING",
							request: arr[i].request ? arr[i].request : arr[i],
						},
					]);
					this.pendingCount++;
				} else {
					this.processedItems = Object.freeze([
						...this.processedItems,
						res.data,
					]);
					this.successfulCount++;
				}
			} catch (err) {
				this.processedItems = Object.freeze([
					...this.processedItems,
					{
						...arr[i],
						status: "FAILED",
						request: arr[i].request ? arr[i].request : arr[i],
					},
				]);
				this.failedCount++;
			}

			this.processedItemsCount++;

			if (i % 50 === 0) {
				await new Promise((resolve) => setTimeout(resolve, 0)); // FREE UP BROWSER MEMORY
			}

			if (this.shouldProcessNext) {
				await this.cycleRequests(arr, i + 1, isNewBatch);
			}
		},
		async retryItem(item, index) {
			this.shouldProcessNext = true;
			await this.processItem(
				item.batchId ? item : this.buildOrderObjectFromItemModel(item),
				true,
			) // if item contains batchId field,
				// then it is already formatted for processing,
				// otherwise run through the adapter
				.then((res) => {
					this.processedItems[index] = res.data;
				})
				.catch((err) => {
					this.processedItems[index] = item;
				})
				.finally(() => {
					this.failedItems = this.processedItems.filter(
						(it) => it.status === "FAILED",
					);
					this.successfulItems = this.processedItems.filter(
						(it) => it.status === "SUCCESSFUL",
					);
					this.status = "PROCESSING_COMPLETE";
				});
		},
		async retryPendingItems() {
			const pendingItemsArray = [];
			const otherItemsArray = [];
			this.shouldProcessNext = true;
			// FETCH BATCH AND SORT ITEMS
			this.$store.commit("busyStatus", true);
			await this.fetchBatchOrder(this.batchId);
			this.$store.commit("busyStatus", false);
			this.processedItems.forEach((item) =>
				item.status === "PENDING"
					? pendingItemsArray.push(item)
					: otherItemsArray.push(item),
			);
			this.processedItems = otherItemsArray;
			this.pendingCount = 0; // RESET PENDING COUNT
			this.processedItemsCount = this.processedItems.length;
			await this.cycleRequests(pendingItemsArray, 0, false);
		},
		async fetchBatchOrder(id) {
			let data;

			try {
				const batchOrderResponse = await http.authReq(
					`/dashboard/batch-orders/${id}`,
				);

				data = batchOrderResponse.data;
			} catch (e) {
				this.snackBar = {
					show: true,
					message: `${e.message}. Please contact Buypower Support.`,
				};
				return this.$router.push("/batch-order");
			}

			this.shouldProcessNext = true;
			this.processedItems = data.batchOrderItems;
			const up = this.sieveItems(data);
			this.unprocessedItems = up;
			this.totalItemsCount =
				data.itemCount || data.payload.length || "Undefined Length";
			this.processedItemsCount = data.batchOrderItems.length;

			this.failedItems = data.batchOrderItems.filter(
				(item) => item.status === "FAILED",
			);

			this.failedCount = this.failedItems.length;

			this.successfulItems = data.batchOrderItems.filter(
				(item) => item.status === "SUCCESSFUL",
			);

			this.successfulCount = this.successfulItems.length;

			this.pendingItems = data.batchOrderItems.filter(
				(item) => item.status === "PENDING",
			);

			this.pendingCount = this.pendingItems.length;

			if (this.unprocessedItems.length > 0) {
				this.remainingItemsCount = this.unprocessedItems.length;
				this.status = "PROCESSING_INCOMPLETE";

				this.snackBar = {
					show: true,
					message: `Batch Processing Incomplete ::: ${
						this.remainingItemsCount
					} Orders Pending`,
				};
			} else {
				this.status = "PROCESSING_COMPLETE";
			}

			// IF NO ITEMS HAVE BEEN PROCESSED, BEGIN PROCESSING IMMEDIATELY
			if (this.processedItems.length === 0) {
				this.snackBar = {
					show: true,
					message: "New Batch::: Beginning Processing!",
				};

				const preppedArray = data.payload.map((item) => ({
					...item,
					batchId: this.batchId,
				}));

				await this.cycleRequests(preppedArray, 0, true);
			}

			return true;
		},
		async fetchBatchOrderItem(id) {
			this.state = "view_response";
			await http
				.authReq(`/dashboard/batch-orders/${this.batchId}/items/${id}`)
				.then((res) => {
					this.selectedItem = res.data;
				})
				.catch((err) => {
					this.selectedItem = { error: err };
				});
		},
	},
	mounted() {
		// fetch all batch orders created by user;
		// pull batch order from url;
		const batchId = this.$route.params.id;
		this.batchId = batchId;
		this.fetchBatchOrder(batchId);
	},
};
</script>

<style scoped>
#app {
	max-width: 400px;
	margin: auto;
	text-align: center;
}

.sidepane {
	background: #fff;
	border: solid 1px #444444ff;
	border-radius: 8px;
	height: 600px;
	padding: 16px;
	box-sizing: border-box;
	overflow-y: scroll;
}

table tr > th,
td {
	text-align: left;
}
#resume-button {
	background: #ff9800;
	color: #fff;
	width: fit-content;
	padding: 12px 24px;
	margin: 0;
	margin-left: auto;
	border-radius: 4px;
	display: block;
}

.table-container {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
}

.table-parent {
	overflow: scroll;
	height: 600px;
	scrollbar-width: none;
	border: none;
	border-radius: 8px;
}

.table-parent::-webkit-scrollbar {
	display: none;
}

.button {
	background: #ff9800;
	color: #fff;
	width: 100%;
	border: none;
	opacity: 0.8;
	transition: all 0.25s ease-in-out;
	max-width: 500px;
	margin: 0 auto;
	display: block;
	margin-top: 16px;
}

.button:hover {
	cursor: pointer;
	opacity: 1;
}

.table-row {
	height: 50px;
	border: none;
	opacity: 1;
	transition: all 0.5s ease-in-out;
}

.table-row :hover {
	opacity: 1;
	cursor: pointer;
}

table {
	overflow-x: scroll;
	border-collapse: collapse; /* Ensures borders are collapsed into a single border */
	table-layout: fixed;
	display: table;
}

table th,
table td {
	padding: 10px;
	width: 100px;
	text-align: left;
	border: none; /* Removes borders from table cells */
}

table tr:nth-child(even) {
	background: rgba(255, 152, 0, 0.3); /* Light gray for even rows */
}

table tr:nth-child(odd) {
	background-color: #ffffff; /* White for odd rows */
}

.top-button-container {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	margin-left: auto;
}

.top-button {
	padding: 4px 8px;
	border: solid 1px #f19d38;
	border-radius: 4px;
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	opacity: 0.8;
	transition: all 0.25s ease-in-out;
	color: #f19d38;
	font-family: "Open Sans";
	font-size: 16px;
	font-weight: 400;
	margin-left: 16px;
}

.top-button:hover {
	cursor: pointer;
	opacity: 1;
}

.top-button img {
	width: 14px;
	height: 14px;
	margin-right: 8px;
}

#tab-container {
	display: inherit;
	padding: 4px;
	background: #f5f5f5;
	border: none;
	border-radius: 4px;
}

.tab {
	font-family: "Open Sans";
	font-size: 12px;
	color: #6d6d6d;
	padding: 4px 8px;
	line-height: 30px;
	border-radius: 4px;
}

.tab:hover {
	cursor: pointer;
}

.order-summary {
	padding: 16px 24px;
	box-sizing: border-box;
	background: #fff;
	border: none;
	border-radius: 4px;
	display: flex;
	flex-flow: row nowrap;
	justify-items: space-between;
	align-items: center;
	font-family: "Open Sans";
	font-weight: 400;
	width: 100%;
	margin-bottom: 8px;
}

.order-status {
	width: 20%;
}

.order-details {
	width: 60%;
	display: inherit;
	flex-flow: row wrap;
}

.order-actions {
	width: 20%;
	color: #8ca32b;
	font-size: 14px;
	margin-left: auto;
}

.order-actions span {
	opacity: 0.8;
	transition: all 0.25s ease-in-out;
	text-align: right;
}

.order-actions span:hover {
	cursor: pointer;
	opacity: 1;
}

.order-status-text {
	font-size: 14px;
	padding: 8px;
	border: none;
	border-radius: 50px;
}

#response_modal {
	position: fixed;
	width: 100%;
	height: 700px;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.5);
	z-index: 999999999;
	display: flex;
	justify-content: center;
	align-items: center;
}

#response_batch {
	width: 800px;
	height: 550px;
	border-radius: 8px;
	background: #fff;
	padding: 16px 40px;
	box-sizing: border-box;
	position: relative;
}

#response_container {
	width: 100%;
	height: 410px;
	overflow-y: scroll;
	scrollbar-width: none;
	margin-bottom: 16px;
}

#empty_response {
	line-height: 410px;
	font-size: 16px;
}

#response_container::-webkit-scrollbar {
	display: none; /* Hides the scrollbar */
}

.response_header {
	font-family: "Open Sans";
	font-weight: 500;
	font-size: 18px;
	margin-bottom: 32px;
}

.recorded_at_time {
	margin-bottom: 16px;
}

.response_text {
	font-family: "Open Sans";
	font-size: 16px;
	font-weight: 400;
	color: #6d6d6d;
	margin: 0;
	padding: 0;
}

.cancel_response {
	width: 100%;
	text-align: right;
	font-family: "Open Sans";
	font-size: 16px;
	font-weight: 400;
	color: #6d6d6d;
	margin-top: 32px;
	position: absolute;
	bottom: 30px;
	right: 20px;
}

.cancel_response:hover {
	cursor: pointer;
}

.response_line {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	font-family: "Open Sans";
}

.response_title {
	font-weight: 700;
	font-size: 14px;
}

.processing_info {
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
}

#processing_info p {
	margin: 0;
	padding: 0;
	margin-left: 8px;
}

#processing_info_container {
	margin-left: 16px;
	display: flex;
	flex-flow: row nowrap;
}

.loader {
	border: 4px solid #bfbfbf;
	border-top: 4px solid #f19d38;
	border-radius: 50%;
	width: 24px;
	height: 24px;
	animation: spin 2s linear infinite;
	margin: 0;
	margin-right: 16px;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

#export-button {
	background: #67ad5b;
	color: #ffffff;
	width: fit-content;
	padding: 12px 24px;
	margin: 0;
	margin-left: auto;
	border-radius: 4px;
	display: block;
}

#export-button a {
	display: block;
	height: 100%;
	color: #fff;
	text-decoration: none;
}

#export-button:visited {
	color: #fff;
	text-decoration: none;
}

#export-button:focus {
	color: #fff;
	text-decoration: none;
}

#export-button:hover {
	color: #fff !important;
	text-decoration: none;
}

.order-detail-title {
	font-weight: 600;
	font-size: 14px;
	text-align: center;
}

.order-detail-content {
	font-weight: 700;
	font-size: 16px;
	text-align: center;
	color: #737373;
}

.order-detail-item {
	display: flex;
	flex-flow: column nowrap;
	width: 33.3333333%;
	margin-bottom: 8px;
}

.text-muted {
	color: #929292;
}

.m-0 {
	margin: 0px;
	padding: 0px;
}

.ml-2 {
	margin-left: 16px;
}

.loading_response {
	width: 100%;
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
}
</style>
